import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import PatientsTable from "../tables/PatientsTable";
import { get } from "../../utility/fetch";
import Pagination from "rc-pagination";
import { GridLoader } from "react-spinners";

function ManageRequest() {
  const [patientData, setPatientData] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPaginationCount, setTotalPaginationCount] = useState(0);
  const [activeCard, setActiveCard] = useState("to-be-sent-to-finance");
  const [loading, setLoading] = useState(false);

  // Map card keys to endpoints
  const endpoints = {
    "to-be-sent-to-finance": "/patient/list/1/100/to-be-sent-to-finance",
    "awaiting-payment": "/patient/list/1/100/un-paid",
    "to-be-dispensed": "/patient/list/1/100/paid-and-emergency-appointments",
    dispensed: "/patient/list/1/100/dispensed",
  };

  const getPatients = async (card = activeCard, page = 1) => {
    setLoading(true);
    try {
      let res = await get(endpoints[card]);
      setTotalPaginationCount(res?.totalPages * 10 || 0);
      setPatientData(res.resultList);
    } catch (error) {
      setPatientData([]);
    }
    setLoading(false);
  };

  const handleCardClick = (cardKey) => {
    setActiveCard(cardKey);
    setPageNumber(1);
    getPatients(cardKey, 1);
  };

  const handleChangePagination = (page) => {
    setPageNumber(page);
    getPatients(activeCard, page);
  };

  useEffect(() => {
    getPatients(activeCard, pageNumber);
    // eslint-disable-next-line
  }, []);

  return (
    <div className="w-100 m-t-80">
      <h3>Diagnosis & Treatment</h3>

      {/* Cards for filtering table contents */}
      <div className="flex w-100 space-between m-b-20 m-t-20">
        <div className="flex flex-v-center w-100" style={{ gap: "24px" }}>
          <div
            className={`card pointer${
              activeCard === "to-be-sent-to-finance" ? " card-active" : ""
            }`}
            style={{
              maxHeight: "100px",
              width: "23%",
              padding: "20px",
              borderRadius: "10px",
              background:
                activeCard === "to-be-sent-to-finance"
                  ? "linear-gradient(135deg, #ffc107 0%, #fd7e14 100%)"
                  : "#f8f9fa",
              color: activeCard === "to-be-sent-to-finance" ? "#333" : "#555",
              fontWeight: "600",
              boxShadow:
                activeCard === "to-be-sent-to-finance"
                  ? "0 4px 12px rgba(255,193,7,0.2)"
                  : "none",
              border:
                activeCard === "to-be-sent-to-finance"
                  ? "2px solid #fd7e14"
                  : "1px solid #e1e5e9",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onClick={() => handleCardClick("to-be-sent-to-finance")}
          >
            To be Sent to Finance
          </div>
          <div
            className={`card pointer${
              activeCard === "awaiting-payment" ? " card-active" : ""
            }`}
            style={{
              maxHeight: "100px",
              width: "23%",
              padding: "20px",
              borderRadius: "10px",
              background:
                activeCard === "awaiting-payment"
                  ? "linear-gradient(135deg, #17a2b8 0%, #007bff 100%)"
                  : "#f8f9fa",
              color: activeCard === "awaiting-payment" ? "#fff" : "#555",
              fontWeight: "600",
              boxShadow:
                activeCard === "awaiting-payment"
                  ? "0 4px 12px rgba(23,162,184,0.2)"
                  : "none",
              border:
                activeCard === "awaiting-payment"
                  ? "2px solid #007bff"
                  : "1px solid #e1e5e9",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onClick={() => handleCardClick("awaiting-payment")}
          >
            Awaiting Payment
          </div>
          <div
            className={`card pointer${
              activeCard === "to-be-dispensed" ? " card-active" : ""
            }`}
            style={{
              maxHeight: "100px",
              width: "23%",
              padding: "20px",
              borderRadius: "10px",
              background:
                activeCard === "to-be-dispensed"
                  ? "linear-gradient(135deg, #28a745 0%, #218838 100%)"
                  : "#f8f9fa",
              color: activeCard === "to-be-dispensed" ? "#fff" : "#555",
              fontWeight: "600",
              boxShadow:
                activeCard === "to-be-dispensed"
                  ? "0 4px 12px rgba(40,167,69,0.2)"
                  : "none",
              border:
                activeCard === "to-be-dispensed"
                  ? "2px solid #218838"
                  : "1px solid #e1e5e9",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onClick={() => handleCardClick("to-be-dispensed")}
          >
            To be dispensed (Paid)
          </div>
          <div
            className={`card pointer${
              activeCard === "dispensed" ? " card-active" : ""
            }`}
            style={{
              maxHeight: "100px",
              width: "23%",

              padding: "20px",
              borderRadius: "10px",
              background:
                activeCard === "dispensed"
                  ? "linear-gradient(135deg, #6c757d 0%, #343a40 100%)"
                  : "#f8f9fa",
              color: activeCard === "dispensed" ? "#fff" : "#555",
              fontWeight: "600",
              boxShadow:
                activeCard === "dispensed"
                  ? "0 4px 12px rgba(108,117,125,0.2)"
                  : "none",
              border:
                activeCard === "dispensed"
                  ? "2px solid #343a40"
                  : "1px solid #e1e5e9",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onClick={() => handleCardClick("dispensed")}
          >
            Dispensed
          </div>
        </div>
      </div>

      <div className="">
        {loading ? (
          <div
            className="flex flex-h-center flex-v-center"
            style={{ minHeight: "300px" }}
          >
            <GridLoader />
          </div>
        ) : (
          <PatientsTable
            type={
              activeCard === "to-be-sent-to-finance"
                ? "unsent"
                : activeCard === "awaiting-payment"
                ? "awaiting"
                : activeCard === "dispensed"
                ? "dispensed"
                : "paid"
            }
            data={patientData}
            setPatientData={setPatientData}
            setTotalPaginationCount={setTotalPaginationCount}
          />
        )}
        <div className="flex flex-h-end m-t-20">
          <Pagination
            onChange={handleChangePagination}
            current={pageNumber}
            total={totalPaginationCount}
          />
        </div>
      </div>
    </div>
  );
}

export default ManageRequest;
